import {SpacialFn, styled, TextFn, VisualFn} from '@yosmanyga/web-style'
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {DropdownProps} from '@yosmanyga/primitive-ui-spec'

const Dropdown = <T,>({
    value,
    options,
    labelField,
    valueField,
    onChange,
    className
}: DropdownProps<T> & UnnormalizedStyleProps) => {
    return <select
        onChange={(event) => {
            const option = options.find(option => option[valueField] === event.target.value);

            onChange(option as T);
        }}
        defaultValue={value ? value[valueField] as string : ''}
        className={className}
    >
        {options.map((option: T, i: number) => (
            <option key={i} value={option[valueField] as string}>
                {option[labelField] as string}
            </option>
        ))}
    </select>
}

const StyledDropdown = styled(Dropdown)`
    ${({width}) => SpacialFn.compileWidth(SpacialFn.normalizeWidth(width))}
    ${({margin}) => SpacialFn.compileMargin(SpacialFn.normalizeMargin(margin))}
    ${({padding}) => SpacialFn.compilePadding(SpacialFn.normalizePadding(padding))}
    ${({color}) => VisualFn.compileColor(color)}
    ${({background}) => VisualFn.compileBackground(VisualFn.normalizeBackground(background))}
    ${({border}) => VisualFn.compileBorder({...VisualFn.normalizeBorder(border), fix: typeof VisualFn.normalizeBorder(border)?.radius !== 'undefined'})}

    ${({font}) => TextFn.compileFont(font)}
    ${({line}) => TextFn.compileLine(line)}

    :focus {
        outline: none
    }
`

export default StyledDropdown
